import React, { SFC } from 'react';
import List, { ListProps } from '../List';

export type GridListProps = ListProps;

const GridList: SFC<GridListProps> = props => <List {...props} />;

export default GridList;
